import React from 'react';


const NullValue = () => {
  return (<></>);
}

export default NullValue;